import { render, staticRenderFns } from "./modulos.vue?vue&type=template&id=4ee961ee&scoped=true"
import script from "./modulos.vue?vue&type=script&lang=js"
export * from "./modulos.vue?vue&type=script&lang=js"
import style0 from "./modulos.vue?vue&type=style&index=0&id=4ee961ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee961ee",
  null
  
)

export default component.exports